import { createReducer, on } from '@ngrx/store';
import { ThemeModeState } from './theme-mode.state';
import * as ThemeActions from './theme-mode.actions';
import { ThemeModeService } from '@core/services/theme-mode.service';
import { DARK_MODE, LIGHT_MODE } from '@core/constants/theme-modes';

const themeModeService = new ThemeModeService();

const initialState: ThemeModeState = {
  mode: themeModeService.getLocalStorageThemeMode(),
};

export const themeReducer = createReducer(
  initialState,
  on(ThemeActions.toggleThemeMode, (state): ThemeModeState => {
    const mode = state.mode === LIGHT_MODE ? DARK_MODE : LIGHT_MODE;
    themeModeService.setLocalStorageThemeMode(mode);
    
    return { ...state, mode };
  })
);
